
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("93jah", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $559b2523fdd8d5f2$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $559b2523fdd8d5f2$export$2e2bcd8739ae039 = {
    'editorExtensionLinkCreate.confluencePage.newDraftTitle': 'Side uden titel',
    'editorExtensionLinkCreate.confluencePage.quickInsert.description': "Opret en ny side, og inds\xe6t den som et link",
    'editorExtensionLinkCreate.confluencePage.quickInsert.title': 'Opret Confluence-side',
    'editorExtensionLinkCreate.confluencePage.successFlag.action.open': "\xc5bn i Confluence",
    'editorExtensionLinkCreate.confluencePage.successFlag.description': 'Din side er oprettet',
    'editorExtensionLinkCreate.confluencePage.successFlag.title': 'Siden blev oprettet',
    'editorExtensionLinkCreate.confluencePage.title': 'Opret ny side',
    'editorExtensionLinkCreate.genericError.description': "Opdater siden, og pr\xf8v igen.",
    'editorExtensionLinkCreate.genericError.title': 'Noget gik galt',
    'editorExtensionLinkCreate.jiraIssue.quickInsert.description': "Opret en sag p\xe5 samme linje, og inds\xe6t sagen som et link",
    'editorExtensionLinkCreate.jiraIssue.quickInsert.title': 'Opret Jira-sag',
    'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': "\xc5bn i Jira",
    'editorExtensionLinkCreate.jiraIssue.successFlag.description': 'Din sag er oprettet',
    'editorExtensionLinkCreate.jiraIssue.successFlag.title': 'Sagen blev oprettet',
    'editorExtensionLinkCreate.jiraIssue.title': 'Opret ny sag',
    'editorExtensionLinkCreate.keyword.create': 'opret',
    'editorExtensionLinkCreate.keyword.issue': 'sag',
    'editorExtensionLinkCreate.keyword.new': 'ny',
    'editorExtensionLinkCreate.keyword.page': 'side',
    'editorExtensionLinkCreate.keyword.publish': 'udgiv',
    'editorExtensionLinkCreate.keyword.raise': 'opret',
    'editorExtensionLinkCreate.keyword.space': "omr\xe5de",
    'editorExtensionLinkCreate.keyword.ticket': 'supportanmodning'
};

});


//# sourceMappingURL=da.971974ab.js.map
